import { getCountry } from 'utils/country';
import countries from 'constants/countries';
import units from 'constants/units';

export const getDatPickerFormat = () => {
  const country = getCountry();

  switch (country) {
    case countries.US:
      return 'MM/dd/yyyy';
    case countries.UK:
      return 'dd/MM/yyyy';
    case countries.FR:
      return 'dd/MM/yyyy';
    case countries.EU:
      return 'dd/MM/yyyy';
    case countries.DE:
      return 'dd/MM/yyyy';
    default:
      throw Error('getDatPickerFormat was called with a non existing country ' + country);
  }
};

export const getMeasure = () => {
  const country = getCountry();
  switch (country) {
    case countries.US:
      return units.imperial;
    case countries.UK:
      return units.imperial;
    case countries.FR:
      return units.metric;
    case countries.EU:
      return units.metric;
    case countries.DE:
      return units.metric;
    default:
      throw Error('getMeasure was called with a non existing country ' + country);
  }
};

export const formatOptions = {
  [countries.US]: {
    thousandSeparator: ',',
    decimalSeparator: '.',
    roundNearest: 1000,
    withTruncation: true,
  },
  [countries.UK]: {
    thousandSeparator: ',',
    decimalSeparator: '.',
    roundNearest: 1000,
    withTruncation: true,
  },
  [countries.FR]: {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    roundNearest: 50,
    withTruncation: false,
  },
  [countries.EU]: {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    roundNearest: 100,
    withTruncation: false,
  },
  [countries.DE]: {
    thousandSeparator: '.',
    decimalSeparator: ',',
    roundNearest: 50,
    withTruncation: false,
  },
};

export const getFormatSeparatorsOptions = () => {
  const { thousandSeparator, decimalSeparator, roundNearest, withTruncation } = formatOptions[getCountry()];
  return { thousandSeparator, decimalSeparator, roundNearest, withTruncation };
};

export const decimalPrecision = 2;
